"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExchangeConfigurationV1 = exports.isExchangeIaV1 = exports.isExchangeLeitungV1 = exports.isExchangeKetteV1 = exports.isExchangeArticleV1 = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const isExchangeArticleV1 = (whatever, { checkArtNrGenerated } = { checkArtNrGenerated: true }) => {
    if (!whatever || typeof whatever !== 'object') {
        return false;
    }
    const obj = whatever;
    return Boolean(
    // must not have
    !obj.EntityId &&
        // must have
        obj.ArticleType &&
        (obj.ArtNrGenerated || !checkArtNrGenerated));
};
exports.isExchangeArticleV1 = isExchangeArticleV1;
const isExchangeKetteV1 = (whatever) => {
    const possibleKette = whatever;
    if ((possibleKette === null || possibleKette === void 0 ? void 0 : possibleKette.ArticleType) !== echain_product_models_1.ArticleType.kette)
        return false;
    if (!possibleKette.KetteSerieType)
        return false;
    return (0, exports.isExchangeArticleV1)(whatever);
};
exports.isExchangeKetteV1 = isExchangeKetteV1;
const isExchangeLeitungV1 = (whatever) => {
    const possibleLeitung = whatever;
    if ((possibleLeitung === null || possibleLeitung === void 0 ? void 0 : possibleLeitung.ArticleType) !== echain_product_models_1.ArticleType.leitung)
        return false;
    return (0, exports.isExchangeArticleV1)(whatever, {
        // only check the ArtNrGenerated if it is NOT a placeholder cable
        checkArtNrGenerated: Boolean(possibleLeitung.IsPlaceholder) === false,
    });
};
exports.isExchangeLeitungV1 = isExchangeLeitungV1;
const isExchangeIaV1 = (whatever) => {
    const possibleIa = whatever;
    if ((possibleIa === null || possibleIa === void 0 ? void 0 : possibleIa.ArticleType) !== echain_product_models_1.ArticleType.ia)
        return false;
    return (0, exports.isExchangeArticleV1)(whatever);
};
exports.isExchangeIaV1 = isExchangeIaV1;
const isExchangeConfigurationV1 = (whatever) => {
    if (!whatever || typeof whatever !== 'object') {
        return false;
    }
    const asConfigJson = whatever;
    const asExchangeConfig = whatever;
    return (asExchangeConfig.ExchangeConfigurationVersion === 'v1' &&
        Boolean(
        // must not have
        !asConfigJson.KetteFilterProperties &&
            !asConfigJson.LeitungFilterProperties &&
            // must have
            asExchangeConfig.DomainVersion &&
            asExchangeConfig.ManagedConfigurationType &&
            asExchangeConfig.IgusGUId &&
            asExchangeConfig.PdfRefs &&
            asExchangeConfig.FileRefs &&
            Array.isArray(asExchangeConfig.Leitungen) &&
            asExchangeConfig.Leitungen.every((a) => (0, exports.isExchangeLeitungV1)(a)) &&
            Array.isArray(asExchangeConfig.AEs) &&
            asExchangeConfig.AEs.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.IAs) &&
            asExchangeConfig.IAs.every((a) => (0, exports.isExchangeIaV1)(a)) &&
            Array.isArray(asExchangeConfig.Zugentlastungen) &&
            asExchangeConfig.Zugentlastungen.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.Verpackungen) &&
            asExchangeConfig.Verpackungen.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.Konfektionierungen) &&
            asExchangeConfig.Konfektionierungen.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.Fuehrungsrinnen) &&
            asExchangeConfig.Fuehrungsrinnen.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.MontageSets) &&
            asExchangeConfig.MontageSets.every((a) => (0, exports.isExchangeArticleV1)(a)) &&
            Array.isArray(asExchangeConfig.MontBes) &&
            asExchangeConfig.MontBes.every((a) => (0, exports.isExchangeArticleV1)(a))));
};
exports.isExchangeConfigurationV1 = isExchangeConfigurationV1;
//# sourceMappingURL=ExchangeConfigurationV1.js.map